import { IconButton, type IconButtonProps } from '@mui/material'
import { Favorite, FavoriteBorder } from '@tunasong/icons'
import { type FC } from 'react'
import type { FavoriteControlProps } from './favorite-props.js'
import { useFavorites } from './favorites.hook.js'

type FavoriteIconProps = FavoriteControlProps<IconButtonProps>

export const FavoriteIcon: FC<FavoriteIconProps> = props => {
  const { onClick, entity, ...restProps } = props

  const { isFavorite, toggleFavorite, getFavoriteTemplateFromEntity } = useFavorites()

  const favorite = isFavorite(entity)
  const FavoriteIcon = favorite ? Favorite : FavoriteBorder

  return (
    <IconButton
      {...restProps}
      color={favorite ? 'error' : 'inherit'}
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        const template = getFavoriteTemplateFromEntity(entity)
        toggleFavorite(template)
        if (onClick) {
          onClick(ev)
        }
      }}
      aria-label={favorite ? 'Remove from favorites' : 'Add to favorites'}
      sx={{ flex: '0 0 auto', ...restProps.sx }}
    >
      <FavoriteIcon />
    </IconButton>
  )
}

export default FavoriteIcon
